import React from 'react';
import { BaseTrackItemProps } from './BaseTrackItem';

export default function BgMusicTrackItem({ clip, pixelsPerSecond, isSelected, onSelect }: BaseTrackItemProps) {
  const clipWidth = clip.duration * pixelsPerSecond;
  const isEmpty = clip.name === '无背景音乐';

  const getBackgroundColor = () => {
    return isEmpty ? 'bg-gray-500/50' : 'bg-green-500/50';
  };

  const getSelectionStyle = () => {
    if (isSelected) return 'ring-2 ring-green-400 bg-green-200/30 shadow-lg';
    return '';
  };

  return (
    <div
      className={`absolute top-1 bottom-1 rounded cursor-pointer hover:opacity-80 transition-all overflow-hidden ${getBackgroundColor()
        } ${getSelectionStyle()}`}
      style={{
        left: `${clip.startTime * pixelsPerSecond}px`,
        width: `${clipWidth}px`
      }}
      onClick={onSelect}
    >
      {isEmpty ? (
        <div className="p-1 h-full flex items-center justify-center">
          <span className="text-xs text-gray-400 truncate">无背景音乐</span>
        </div>
      ) : !isEmpty && !clip.name && clip.isGenerating ? (
        <div className="p-1 h-full flex items-center">
          <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
          <span className="text-xs text-white truncate">加载中...</span>
        </div>
      ) : (
        <div className="absolute inset-0 flex items-center justify-around px-1">
          {Array.from({ length: Math.max(Math.floor(clipWidth / 4), 10) }, (_, i) => {
            const height = 15 + Math.sin(i * 0.3) * 8 + Math.cos(i * 0.2) * 5;
            return (
              <div
                key={i}
                className="bg-green-300 rounded-sm"
                style={{
                  width: '2px',
                  height: `${height}%`,
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}